import { render, staticRenderFns } from "./VeStuHealthScoreBase.vue?vue&type=template&id=c98f59ce&scoped=true"
import script from "./VeStuHealthScoreBase.vue?vue&type=script&lang=js"
export * from "./VeStuHealthScoreBase.vue?vue&type=script&lang=js"
import style0 from "./VeStuHealthScoreBase.vue?vue&type=style&index=0&id=c98f59ce&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c98f59ce",
  null
  
)

export default component.exports